import { render } from "./Item4base.vue?vue&type=template&id=6f3bd89e&scoped=true"
import script from "./Item4base.vue?vue&type=script&lang=js"
export * from "./Item4base.vue?vue&type=script&lang=js"

import "./Item4base.vue?vue&type=style&index=0&id=6f3bd89e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f3bd89e"

export default script